(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["making-vessel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('making-vessel')) {
    customElements.define('making-vessel', class extends HTMLElement {
      connectedCallback() {
        const hex = (h) => { h = (h || '#000000').replace('#', ''); return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16)); };
        const lerp = (a, b, t) => a + (b - a) * t;
        const ease = (t) => t * t * (3 - 2 * t);
        const mix = (a, b, t) => 'rgb(' + hex(a).map((v, i) => Math.round(lerp(v, hex(b)[i], t))).join(',') + ')';
        const shade = (h, k) => '#' + hex(h).map((v) => Math.max(0, Math.min(255, Math.round(v * k))).toString(16).padStart(2, '0')).join('');
        const g = this.dataset.glaze || '#EDE9E1';
        this.palette = [
          { edge: '#4a3226', mid: '#6d4c3b', light: '#8c6752', rim: '#7d5a47', dot: '#6d4c3b' },
          { edge: '#5e3f30', mid: '#8a634f', light: '#a9806a', rim: '#9a735e', dot: '#8a634f' },
          { edge: '#a8927f', mid: '#cdb9a6', light: '#e6d8ca', rim: '#dccbbb', dot: '#e9ddd1' },
          { edge: '#a45a3f', mid: '#c97d5d', light: '#e3a283', rim: '#d88f6e', dot: '#e6ad90' },
          { edge: shade(g, .62), mid: shade(g, .88), light: shade(g, 1.06), rim: shade(g, .96), dot: '#ffffff' }
        ];
        this.h = { lerp, ease, mix };
        this.els = {
          body: this.querySelector('[data-body]'), rim: this.querySelector('[data-rim]'), inner: this.querySelector('[data-inner]'),
          dots: this.querySelector('[data-dots]'), ticks: this.querySelector('[data-ticks]'), shine: this.querySelector('[data-shine]'),
          shadow: this.querySelector('[data-shadow]'), stops: this.querySelectorAll('stop[data-c]'),
          stages: this.querySelectorAll('[data-stage]'), bignum: this.querySelector('[data-bignum]')
        };
        const ns = 'http://www.w3.org/2000/svg';
        this.dotEls = Array.from({ length: 25 }, () => { const c = document.createElementNS(ns, 'circle'); this.els.dots.appendChild(c); return c; });
        this.tickEls = Array.from({ length: 12 }, () => { const c = document.createElementNS(ns, 'circle'); c.setAttribute('r', '2.2'); c.setAttribute('fill', '#C9A58C'); this.els.ticks.appendChild(c); return c; });
                this.p = 0; this.rot = 0;
        this.measureHead = () => {
          const group = document.querySelector('.shopify-section-group-header-group');
          const h = group ? Math.round(group.getBoundingClientRect().height) : 0;
          this.style.setProperty('--mk-head', (h || 110) + 'px');
        };
        this.measureHead();
        window.addEventListener('resize', this.measureHead);
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.reduce) { this.p = 4; this.draw(); return; }
        this.onScroll = () => {
          const r = this.getBoundingClientRect();
          const total = r.height - window.innerHeight;
          const t = total > 0 ? Math.max(0, Math.min(1, -r.top / total)) : 0;
          this.p = t * 4;
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.draw();
        let last = performance.now();
        const loop = (now) => {
          const dt = Math.min(.05, (now - last) / 1000); last = now;
          const r = this.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight) { this.rot = (this.rot + dt * .9) % (Math.PI * 2); this.draw(); }
          this.raf = requestAnimationFrame(loop);
        };
        this.raf = requestAnimationFrame(loop);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }
      draw() {
        const { lerp, ease, mix } = this.h, p = this.p, rot = this.rot, e = this.els, f = (n) => n.toFixed(1);
        const seg = (a, b) => Math.max(0, Math.min(1, (p - a) / (b - a)));
        const i0 = Math.min(3, Math.floor(p)), t = ease(p - i0), A = this.palette[i0], B = this.palette[i0 + 1];
        const c = {}; ['edge', 'mid', 'light', 'rim', 'dot'].forEach((k) => { c[k] = mix(A[k], B[k], t); });
        e.stops.forEach((s) => s.setAttribute('stop-color', c[s.dataset.c]));

        const lump = [[22, 168], [84, 182], [128, 222], [140, 268], [120, 312], [74, 326]];
        const bowl = [[150, 206], [158, 226], [156, 258], [140, 292], [104, 318], [62, 326]];
        const form = ease(seg(0, 1)), shrink = lerp(1, .93, ease(seg(1, 2)));
        const pts = lump.map((q, i) => [lerp(q[0], bowl[i][0], form) * shrink, 326 - (326 - lerp(q[1], bowl[i][1], form)) * shrink]);
        const seq = [[200, pts[0][1]]].concat(pts.map((q) => [200 + q[0], q[1]]), pts.slice().reverse().map((q) => [200 - q[0], q[1]]), [[200, pts[0][1]]]);
        let d = 'M 200 ' + f(pts[0][1]);
        for (let k = 1; k < seq.length - 1; k++) {
          const p1 = seq[k], p2 = seq[k + 1];
          d += ' Q ' + f(p1[0]) + ' ' + f(p1[1]) + ' ' + f((p1[0] + p2[0]) / 2) + ' ' + f((p1[1] + p2[1]) / 2);
        }
        e.body.setAttribute('d', d + ' Z');

        const rx = pts[0][0], ry = pts[0][1], ro = ease(seg(.2, 1));
        e.rim.setAttribute('cy', f(ry)); e.rim.setAttribute('rx', f(rx)); e.rim.setAttribute('ry', f(rx * .26)); e.rim.setAttribute('fill', c.rim); e.rim.setAttribute('opacity', f(ro));
        e.inner.setAttribute('cy', f(ry + 2)); e.inner.setAttribute('rx', f(rx * .86)); e.inner.setAttribute('ry', f(rx * .2)); e.inner.setAttribute('opacity', f(ro));
        e.shadow.setAttribute('rx', f(pts[5][0] + 30));

        const showDots = this.dataset.dots !== 'false';
        const dv = showDots ? ease(seg(1, 2)) : 0;
        let n = 0;
        [{ y: 2, count: 14, r: 5.5, off: 0, dy: 8 }, { y: 4, count: 11, r: 4.6, off: .22, dy: 0 }].forEach((row) => {
          const yy = pts[row.y][1] + row.dy, rr = pts[row.y][0] * .98;
          for (let k = 0; k < row.count; k++) {
            const a = rot + (k / row.count) * Math.PI * 2 + row.off, z = Math.cos(a), el = this.dotEls[n++];
            if (!el) continue;
            if (z < .05 || dv === 0) { el.setAttribute('opacity', '0'); continue; }
            el.setAttribute('cx', f(200 + Math.sin(a) * rr)); el.setAttribute('cy', f(yy + z * 6));
            el.setAttribute('r', f(row.r * (.55 + .45 * z))); el.setAttribute('fill', c.dot); el.setAttribute('opacity', f(dv * (.35 + .65 * z)));
          }
        });
        this.tickEls.forEach((el, k) => {
          const a = rot * .6 + (k / 12) * Math.PI * 2;
          el.setAttribute('cx', f(200 + Math.sin(a) * 150)); el.setAttribute('cy', f(330 + Math.cos(a) * 29)); el.setAttribute('opacity', f(.25 + .5 * (Math.cos(a) + 1) / 2));
        });
        e.shine.setAttribute('cx', f(200 - pts[2][0] * .42 + Math.sin(rot * 2) * 6)); e.shine.setAttribute('cy', f(pts[2][1] + 4)); e.shine.setAttribute('opacity', f(ease(seg(3, 4))));

        const cur = Math.min(e.stages.length - 1, Math.round(p));
        e.stages.forEach((s, k) => s.classList.toggle('is-active', k === cur));
        if (e.bignum && e.stages[cur]) e.bignum.textContent = e.stages[cur].querySelector('.mk-stage__num').textContent;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
